<template id="activityType">
    <div>
        <router-view/>
    </div>
</template>

<script>
    import Vue from "vue";

    const ActivityType = Vue.component('activityType', {
        name: 'activityType',
        template: '#activityType',
        props: ['id']
    });

    export default {
        name: "ActivityType",

        computed: {
            componentLoader() {
                console.log(this.$route.params.id);
                return () => import("@/components/"+ this.$route.params.id+".vue");
            }
        }

    }
</script>